import React from 'react';
import { Activity, Shield, Sparkles } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const tabs = [
  { to: '/dashboard/admin', label: 'Analytics', icon: Activity, end: true },
  { to: '/dashboard/admin/subscribers', label: 'Subscriber access', icon: Sparkles, end: false },
  { to: '/dashboard/scrapers', label: 'Scrapers', icon: Shield, end: false },
];

const AdminTabs: React.FC = () => (
  <nav aria-label="Admin sections" className="mb-7 overflow-x-auto custom-scrollbar">
    <div className="inline-flex min-w-full gap-1 rounded-xl border border-ink-200 bg-surface p-1 sm:min-w-0">
      {tabs.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end}
        className={({ isActive }) => `inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 py-2.5 text-sm font-medium transition-colors sm:flex-none ${isActive ? 'bg-brand-600 text-white shadow-sm' : 'text-ink-600 hover:bg-ink-50'}`}>
        <Icon className="h-4 w-4" />{label}
      </NavLink>)}
    </div>
  </nav>
);

export default AdminTabs;
